import React, { useState } from "react";
import TopMenuItem from "./TopMenuItem";
import OptionNav from "../OptionNav/OptionNav";
import "./AppMenu.css";

function TopMenu({ name, options, ...props }) {
  const [activeSection, setActiveSection] = useState(0);
  const root = process.env.REACT_APP_CMS_STATIC;

  return (
    <div className="d-flex">
      {options.map((option, index) =>
        option.displayText === "Ahorro Y Crédito" ? (
          <TopMenuItem
            key={index}
            placement="top"
            name={option?.displayText}
            section={index + 1}
            activeSection={activeSection}
            setActiveSection={setActiveSection}
            active={activeSection === index + 1 ? true : false}
            iconUrl={root + option?.icono?.urls[0]}
          />
        ) : (
          <OptionNav
            key={index}
            name={option?.displayText}
            icon={root + option?.icono?.urls[0]}
            title={option?.displayText}
            url={option?.rutadestino}
            textColor="#fff"
          />
        )
      )}
    </div>
  );
}
export default TopMenu;
